import { I_CurrentUserResponseData } from "../model/responses/current-user";

export const MAXCOREOldAdapter = (
  data: I_CurrentUserResponseData,
  token: string
): IMaxcoreDataSession => {
  return {
    account: { id: 1, name: "RE/MAX" },
    agency: {
      id: data.agency_id,
      name: data.agency.name,
      email: data.agency.email,
      phone: ""
    },
    auth_token: token,
    email: data.email,
    international_id: data.international_id,
    mobile: data.mobile,
    peopleId: data.people_id,
    name: data.name,
    phone: data.phone,
    token: "",
    userId: data.user_id,
    userType: data.user_type as unknown as number,
    picture: data.picture,
    has_alterestate_token: data.has_alterestate_token
  };
};

export interface IMaxcoreDataSession {
  auth_token: string | null;
  userId: number | null;
  peopleId: number | null;
  name: string | null;
  phone: string | null;
  mobile: string | null;
  email: string | null;
  userType: number | null;
  account: Account;
  agency: Agency;
  token: string | null;
  international_id: any;
  picture: string | null | null;
  has_alterestate_token: number | null;
}

export interface Account {
  id: number | null;
  name: string;
}

export interface Agency {
  id: number | null;
  name: string | null;
  email: string | null;
  phone: string | null;
}
